import React from 'react';
import styles from './EmptyBank.module.scss';
import emptyBank from '../../../../../../assets/empty-bank.svg';

function EmptyBank({
    text = '',
    style,
    subText,
    buttonComponent = null,
    showExtractCta = false,
    onExtractClick,
}: {
    text?: string;
    style?: React.CSSProperties;
    subText?: string;
    buttonComponent?: React.ReactNode | null;
    showExtractCta?: boolean;
    onExtractClick?: () => void;
}) {
    const displayText = showExtractCta ? 'Bank statement data has not been extracted.' : text;

    return (
        <div className={styles.EmptyBank} style={style}>
            <img src={emptyBank} alt="" height="106px" />
            <span>
                {displayText}
                {showExtractCta && onExtractClick && (
                    <>
                        {' '}
                        <button className={styles.ExtractLink} onClick={onExtractClick}>
                            Extract Now
                        </button>
                    </>
                )}
            </span>

            {subText && <div className={styles.SubText}>{subText}</div>}

            {buttonComponent}
        </div>
    );
}

export default EmptyBank;
